export * from "./mapMarketName";